<template>
  <form class="form-wrapper" @submit.prevent="$emit('submit')">
    <slot></slot>
  </form>
</template>

<script>
export default {

}
</script>
